/** Canonical public path segment for a job (slug when present, else UUID). */
export function jobPublicPathSegment(job) {
  if (!job || typeof job !== "object") return "";
  const slug = String(job.publicSlug || "").trim();
  if (slug) return slug;
  return String(job.id || "").trim();
}

export function jobPublicHref(job) {
  const seg = jobPublicPathSegment(job);
  return seg ? `/jobs/${encodeURIComponent(seg)}` : "/jobs";
}
